import {Component} from 'react';
import EventsHeaderModal from './events_header_modal';
import EventsResponseModal from './events_response_modal';
import { setHeadersForFetch } from '../../objects/CommonUse/set_headers_for_fetch';
import getCurrentDateTime from '../../objects/CommonUse/get_current_date_time';
import EventInputDataset from './datasets/event_input_dataset';
import EventInputTemplateDataset from './datasets/event_input_template';
import {buildUrl } from '../../objects/CommonUse/build_URL';
import Config from '../../config';
import eventFrequencyDataset from './datasets/event_frequency_dataset';

class EventsUpdate extends Component {
    constructor(props) {
        super(props);
        this.adminInfo = this.props.adminInfo();
        this.state={
          openEventsMainModal: false,
          openEventsResponseModal: false,
          allowEventsUpdate: true,
          openEventsUpdateModal: false,
          responseArr: [],
          currentDateTime: getCurrentDateTime(),
          headers: setHeadersForFetch(),
          subProcess: "EventsUpdate",
          environment: Config.dataURL.currentEnv,
         };   
         this.responseArr = [];
         this.eventsObj = "";
    }

    sortEventTitles(){
        var i;
        this.eventTitles=[];
        for (i=0; i<this.adminInfo.eventsData.length; i++){
            this.eventTitles.push(this.adminInfo.eventsData[i].title);
        }
        this.eventTitles = this.eventTitles.sort();
    }
        
    sortConditionsList() {
        var i;
        var condName="";
        var condNameArr=[];
        var careerCondNameArr=[];
        for (i=0; i<this.adminInfo.conditionsData.length; i++){
            // convert condName from index to string
            condName = JSON.parse(JSON.stringify(this.adminInfo.conditionsData[i].condName));
            if (this.adminInfo.conditionsData[i].conditionClass === "career"){
                careerCondNameArr.push(condName);
            }else{
                condNameArr.push(condName);
            }
        }
        this.sortedConditionsData = condNameArr.sort();
        this.sortedCareerTags = careerCondNameArr.sort();
    }
   
    openEventsMainModal(){
        this.setState({openEventsMainModal: true});
    }

    closeEventsMainModal() {
        this.setState({openEventsMainModal: false});
    }
    
    openEventsResponseModal(){
        this.setState({openEventsResponseModal: true});
    }

    closeEventsResponseModal() {
        this.setState({openEventsResponseModal: false});
    }

    
    submitEventsForm(dataObj){
        this.setState({openEventsMainModal: false});
        this.setState({openEventsResponseModal: false});
        if (dataObj.dataType === "header"){
              this.eventsObj = dataObj.eventsObj;
        }else{
              this.responseArr = dataObj.responses; 
        }
       
        if (this.eventsObj.title  && this.eventsObj.title !== ""){
            if (this.responseArr.length > 0 ){
                this.eventsObj.responses = this.responseArr;
                this.saveEventsCollection();
                this.eventsObj = {};
                this.responseArr = [];
                this.message="Updates completed successfully!"
            }else{
                this.message = "Responses have not been entered.  Click on the Events Collection Responses button."
            }
        }else{
            this.message = "Header has not been entered.  Click on the Events Collection Header button."
        }
    }

    processEventDataset(updateType){
        let eventInputDataset = EventInputDataset;
        switch (updateType){
            case "addEvents":
                this.addNewEventsFromUpload(eventInputDataset);
                break;
            case "frequency":
                this.updateFrequency(eventInputDataset);
                break;
            default:
                break;
        }
    }

    addNewEventsFromUpload(eventInputDataset){
         this.eventTemplate = EventInputTemplateDataset;
         if (eventInputDataset.alreadyProcessed === true){
             alert('Event Dataset has already been processed!');
         }else{
            this.newEventList = eventInputDataset.newEventList;
            for (let i=0; i<this.newEventList.length; i++){
                this.newEventList = eventInputDataset.newEventList;
                this.buildHeader(this.newEventList[i]);
                this.responseList = this.newEventList[i].responses;
                let responseArr = [];
                for (let j=0; j<this.responseList.length; j++){
                    this.buildResponse(this.responseList[j]);
                    responseArr.push(this.response);
                }
                this.eventsObj = {...this.eventData, "responses": responseArr};
                this.saveEventsCollection();
            }
         }
    }

    async updateFrequency(){
        //  refer to eventFrequencyUpdate excel dataset in Reports folder
        await this.loadUpdateTestDataset();
        this.updateEventArr = [];
        for (let i=0; i<this.updateEventList.length; i++){
            const eventUpdate = this.updateEventList[i];
            const frequencyObj = eventFrequencyDataset.find(elem => elem.frequency + elem.tier ===
                eventUpdate.FreqName + eventUpdate.FreqTier );
            if (frequencyObj){
                const freqNbr = frequencyObj.freqNbr;
                const frequencyObj2 = {frequencyType: eventUpdate.FreqName, freqPriority: eventUpdate.FreqTier}
                const eventUpdateObj = {_id: eventUpdate.EventID, 
                    frequency: freqNbr, frequencyObj: frequencyObj2 };
                this.updateEventArr.push(eventUpdateObj);
            }else{
                console.log("frequency not found for: ", eventUpdate.FreqName, " tier: ", 
                    eventUpdate.FreqTier);
            }
        }
        this.updateEvents();
    }
    
    async oneTimeEventUpdate(){
        //  refer to eventFrequencyUpdate excel dataset in Reports folder
        await this.loadUpdateTestDataset();
        this.updateEventArr = [];
        for (let i=0; i<this.updateEventList.length; i++){
            const eventUpdate = this.updateEventList[i];
            const updateEventObj = {eventID: eventUpdate.eventID, btnText: eventUpdate.BtnText, 
                creditCardCategory: eventUpdate.TableExpCategory};
            this.updateEventArr.push(updateEventObj)
        }
        this.updateEventBulkUpdate();
    }

    render() {
        this.sortEventTitles();
        this.sortConditionsList();
    return <>
        {this.state.loadingEventsList  ?
            <span></span>
        :
            <div className="col-sm-6 mb-5 input-page-base-card">
                <div className="card mt-3 mr-5 rounded-corners-lg height-max">
                    <h1 className="mt-2 p-0 text-center">Game Administration</h1>
                    <h4 className="text-center">Add to the Events Collection in MongoDB</h4>
                    <div className="mt-0 mb-0 overflow-scroll">
                        <span className="mt-4">
                        {this.state.openEventsMainModal === false ?
                            <div className="text-center mt-5">
                                <button className="btn btn-primary w-50 mt-6" 
                                    onClick ={()=> this.openEventsMainModal()}>
                                         Events Collection Header
                                </button>
                            </div>
                        :
                            <EventsHeaderModal openModal={this.state.openEventsMainModal} 
                                onClose={() => this.closeEventsMainModal()} 
                                onSubmit={(eventObj) => this.submitEventsForm(eventObj)}
                                eventTitles={this.eventTitles}
                                condNames={this.sortedConditionsData}
                                careerTags={this.sortedCareerTags}
                                />
                        }
                        {this.state.openEventsResponseModal === false ?
                            <div className="mt-4 text-center">
                                <button className="btn btn-primary w-50 mt-6" 
                                    onClick ={()=> this.openEventsResponseModal()}>
                                         Events Collection Responses
                                </button>
                            </div>
                        :
                            <EventsResponseModal openModal={this.state.openEventsResponseModal}
                                onClose={() => this.closeEventsResponseModal()} 
                                onDone={(responseObj) => this.submitEventsForm(responseObj)}
                                eventTitles={this.eventTitles}
                                condNames={this.sortedConditionsData}
                                />
                        }
 
                        {this.state.allowEventsUpdate ?
                            <div className="mt-4 text-center">
                                <button className="btn btn-primary w-50 mt-6" 
                                    onClick ={()=> this.processEventDataset("frequency")}>
                                        Update Event Frequency
                                </button>
                            </div>
                        :
                            null
                        }

                        {this.state.allowEventsUpdate ?
                            <div className="mt-4 text-center">
                                <button className="btn btn-primary w-50 mt-6" 
                                    onClick ={()=> this.oneTimeEventUpdate()}>
                                        Update Event Credit Card Category
                                </button>
                            </div>
                        :
                            null
                        }

                        </span>

                        <div className="text-danger text-font-bold text-center mt-5 ml-5 mr-5">
                            {this.message}</div>
                       
                                   
                    </div>
                   
                </div>        
            </div>
        }
        </>
    }

async loadUpdateTestDataset() {
    const funcName = "loadUpdateTestDataset";
    const urlParm = "";
    const uri = buildUrl(this.state.environment, funcName, urlParm);

    try {
        const response = await fetch(uri, {
            method: 'GET',
            headers: this.state.headers,
        });

        if (!response.ok) {
            throw new Error(`Network response was not ok. Status: ${response.status}`);
        }

        const rawData = await response.json();
        const output = JSON.parse(rawData); // Only if your server double-encodes JSON!
        const statusCode = output.statusCode;
        if (statusCode === 200) {
            this.updateEventList = output.body;
        } else {
            const errorObj = {
                function: funcName,
                subProcess: this.state.subProcess,
                status: statusCode,
                message: output.body.message,
                errorObject: this.eventsObj
            };
            this.props.processError(errorObj);
        }

    } catch (error) {
        console.error("Error in loadUpdateTestDataset:", error);
        this.props.processError({
            function: funcName,
            message: error.message,
            errorObject: error
        });
    }
}

updateEvents(){
    const funcName = "updateMultipleEvents";
    const urlParm = "";
    const bodyObject = {eventArr: this.updateEventArr};
    const uri = buildUrl(this.state.environment, funcName, urlParm);
    fetch(uri,
        {
        method:'PUT',
        headers: this.state.headers,
        body: JSON.stringify(bodyObject)
        })
        .then(response => {
            if (response.ok){
                response.json().then(data => {
                    const output = JSON.parse(data);
                        const statusCode = output.statusCode;
                    if (statusCode === 200){
                        alert("The event list has been updated...");
                    }else{
                        const errorObj={function: funcName, subProcess: this.state.subProcess, 
                            status: statusCode, message: output.body.message, errorObject: this.eventsObj};
                        this.props.processError(errorObj);
                    }
            });
        };
    })
}

updateEventBulkUpdate(){
    const funcName = "updateEventBulkWrite";
    const urlParm = "";
    const bodyObject = this.updateEventArr;
    const uri = buildUrl(this.state.environment, funcName, urlParm);
    fetch(uri,
        {
        method:'PUT',
        headers: this.state.headers,
        body: JSON.stringify(bodyObject)
        })
        .then(response => {
            if (response.ok){
                response.json().then(data => {
                    const output = JSON.parse(data);
                        const statusCode = output.statusCode;
                    if (statusCode === 200){
                    //    returnBody = {matched: result.matchedCount, modified: result.modifiedCount, message: "successful update"};
                        alert("The event list has been updated... " +
                           "nbr matched: "  + output.matched + 
                           "nbr updated: "  + output.modifiedCount
                        );
                    }else{
                        const errorObj={function: funcName, subProcess: this.state.subProcess, 
                            status: statusCode, message: output.body.message, errorObject: this.eventsObj};
                        this.props.processError(errorObj);
                    }
            });
        };
    })
}
        
    buildHeader(header){
        this.eventData = {"title": header.title, 
            "description": header.description,
            "frequency": this.eventTemplate.frequency,
            "conditionConnector": this.eventTemplate.conditionConnector, 
            "conditionArr": this.eventTemplate.conditionArr,
            "skipConditionArr": this.eventTemplate.skipConditionArr,
            "backgroundType": this.eventTemplate.backgroundType,
            "imageDir": this.eventTemplate.imageDir,
            "careerTag": this.eventTemplate.careerTag,
            "selectMonthArr": this.eventTemplate.selectMonthArr,
            "gamePhase": this.eventTemplate.gamePhase,
            "eventCategory": this.eventTemplate.eventCategory,
            "dateAdded": this.state.currentDateTime.date,
            "dateUpdated": this.state.currentDateTime.date,
        }
    }

    buildResponse(responseItem){
        this.response = {"btnText": responseItem.btnText,
            "rltnshpScore": this.eventTemplate.rltnshpScore,
            "itemDesc": this.eventTemplate.itemDesc,
            "possibleEffects": [{
                "closureText": responseItem.closureText,
                "category": this.eventTemplate.category,
                "on": this.eventTemplate.on,
                "type": this.eventTemplate.type,
                "duration": this.eventTemplate.duration,
                "odds": this.eventTemplate.odds,
                "replaceAmtSw": this.eventTemplate.replaceAmtSw,
                "triggerCondition": this.eventTemplate.triggerCondition,
                "deleteCondition": this.eventTemplate.deleteCondition,
                "deleteClass": this.eventTemplate.deleteClass,
                "possibleValues": this.eventTemplate.possibleValues,
                "moodPoints": responseItem.moodPoints
            }]
        }
    }
    
    saveEventsCollection() {
        const funcName = "saveEventsCollection";
        const urlParm = "";
        const uri = buildUrl(this.state.environment, funcName, urlParm);
        fetch(uri,
            {
            method:'POST',
            headers: this.state.headers,
            body: JSON.stringify(this.eventsObj)
            })
            .then(response => {
                if (response.ok){
                    response.json().then(data => {
                        const output = JSON.parse(data);
                        const statusCode = output.statusCode;
                        if (statusCode === 200){
                            alert("The new event has been saved!!");
                        }else{
                            const errorObj={function: funcName, subProcess: this.state.subProcess, 
                                status: statusCode, message: output.body.message, errorObject: this.eventsObj};
                            this.props.processError(errorObj);
                        }
                    });
                };
            })
    }

}

export default EventsUpdate;